<template>
  <expandable header="Urine Routine & UPCR" class="mb-10">
    <b-row>
      <b-col cols="12" md="4">
        <input-field
          v-model.trim="form.urine_albumin"
          label="Urine Albumin"
          :disabled="isDisabled"
          @input="onInput"
        ></input-field>
      </b-col>
      <b-col cols="12" md="4">
        <input-field
          v-model.trim="form.urine_rbc"
          label="Urine RBC"
          :disabled="isDisabled"
          @input="onInput"
        ></input-field>
      </b-col>
      <b-col cols="12" md="4">
        <input-field
          v-model.trim="form.urine_pus_cells"
          label="Urine Pus Cells"
          :disabled="isDisabled"
          @input="onInput"
        ></input-field>
      </b-col>
      <b-col cols="12" md="4">
        <input-field
          v-model.trim="form.upcr_protein"
          label="Urine Protein (UPCR)"
          :disabled="isDisabled"
          @input="onInput"
        ></input-field>
      </b-col>
      <b-col cols="12" md="4">
        <input-field
          v-model.trim="form.upcr_creatinine"
          label="Urine Creatinine (UPCR)"
          :disabled="isDisabled"
          @input="onInput"
        ></input-field>
      </b-col>
    </b-row>
  </expandable>
</template>

<script>
import Expandable from "../../Expandable.vue";
import InputField from "../../form/InputField.vue";

export default {
  components: { Expandable, InputField },
  props: {
    value: {},
    isDisabled: { default: false, type: Boolean },
  },
  data() {
    return { form: {} };
  },
  methods: {
    onInput() {
      this.$emit("input", this.form);
    },
  },
  beforeMount() {
    this.form = this.value;
  },
  mounted() {
    this.onInput();
  },
};
</script>
